import React from 'react'

const Logos = ({ block }) => {
  if (block.style === 'Unlimited') {
    block.style_class = ' style-ul'
  }
  else {
    block.style_class = ' style-3pr'
  }

  return (
    <section className={`block ${block._template} ${block.css_class_name} ${block.style_class}`}>
      <div className='container'>
        <div className='logos-wr'>
          {block.items.map((item, index) => {
            return <div key={index} className={`logo${item.url ? ' has-link' : ''}`}>
              {item.url && ( <a href={item.url}></a> )}
              {item.image && (
                <img src={item.image} alt={item.title} title={item.title} />
              )}
            </div>
          })}
        </div>
      </div>
    </section>
  )
}

export default Logos
